const sanitizeAccessCode = (s) => {
  let r = s.toLowerCase();
  r = r.replace(/[^a-zA-Z0-9]/g, "");
  return r;
};

export default sanitizeAccessCode;
